import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "embed",
  "use": "embed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"embed\"><path fill-rule=\"evenodd\" d=\"m4.8 12 4.6-4.6L8 6l-6 6 6 6 1.4-1.4L4.8 12Zm14.4 0-4.6-4.6L16 6l6 6-6 6-1.4-1.4 4.6-4.6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol